import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    categories: {},
    openedCategorie: null,
    categoryLoaded: false,
    loading: false,
    loadingProducts: false,
    searchResults: [],
    searching: false,
    bundles: [],
    bundlesLoaded: false,
    loadingBundles: false,
    packsMode: false,
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
}
